import React from 'react'
import SEOHead from '../components/SEOHead'
import ContactForm from '../components/ContactForm'

export default function Contact() {
  return (
    <>
      <SEOHead
        title="Kontakt Agstner Byg ApS - Ring 52 50 25 43"
        description="Kontakt Agstner Byg ApS i Vissenbjerg for et uforpligtende tilbud på tømrerarbejde, tag eller renovering. Tlf: 52 50 25 43 / Agstnerbyg@icloud.com."
      />

      {/* Hero */}
      <section className="relative py-20 bg-zinc-950 overflow-hidden border-b border-zinc-800">
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/bac61bd8-01e8-4025-a9be-38664430d08c/image00062.jpeg"
            alt="Kontakt Agstner Byg ApS"
            className="w-full h-full object-cover opacity-65"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-zinc-950/85 via-zinc-950/50 to-zinc-950/20" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-orange-500 font-display text-xs uppercase tracking-widest mb-2">
            <span className="w-6 h-0.5 bg-orange-500"></span>
            <span>DIREKTE KONTAKT</span>
          </div>
          <h1 className="text-4xl sm:text-6xl font-display font-black text-white uppercase tracking-tight">
            Kontakt Agstner Byg ApS
          </h1>
          <p className="mt-3 text-base sm:text-lg text-zinc-300 max-w-2xl">
            Har du spørgsmål til en opgave eller ønsker du et uforpligtende tilbud? Ræk ud til os via telefon, e-mail eller kontaktformularen herunder.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-zinc-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Four CTA Contact Boxes (CAD Wireframe style) */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            
            {/* Box 1: Telefon */}
            <div className="bg-zinc-950 p-6 sm:p-8 border border-zinc-800 hover:border-orange-500 transition-all flex flex-col justify-between space-y-6">
              <div>
                <div className="w-12 h-12 bg-orange-500 text-zinc-950 flex items-center justify-center font-bold text-xl mb-6">
                  <i className="fa-solid fa-phone" aria-hidden="true"></i>
                </div>
                <h2 className="text-lg sm:text-xl font-display font-bold text-white uppercase">Ring nu</h2>
                <p className="text-xs text-zinc-400 mt-2 leading-relaxed">
                  Vi svarer gerne på dine spørgsmål og drøfter din opgave over telefonen.
                </p>
                <div className="mt-6 pt-4 border-t border-zinc-800">
                  <p className="text-[10px] text-zinc-500 uppercase font-mono font-semibold">Telefonnummer</p>
                  <a
                    href="tel:+4552502543"
                    className="text-lg sm:text-xl font-display font-black text-orange-500 hover:text-orange-400 transition-colors whitespace-nowrap inline-block mt-0.5"
                  >
                    <span className="whitespace-nowrap">52 50 25 43</span>
                  </a>
                </div>
              </div>
              <a
                href="tel:+4552502543"
                className="w-full py-3.5 px-4 bg-zinc-900 hover:bg-orange-500 hover:text-zinc-950 text-orange-500 font-display font-bold text-xs uppercase tracking-widest border border-zinc-800 text-center transition-all whitespace-nowrap"
              >
                Ring op nu
              </a>
            </div>

            {/* Box 2: E-mail */}
            <div className="bg-zinc-950 p-6 sm:p-8 border border-zinc-800 hover:border-orange-500 transition-all flex flex-col justify-between space-y-6">
              <div>
                <div className="w-12 h-12 bg-orange-500 text-zinc-950 flex items-center justify-center font-bold text-xl mb-6">
                  <i className="fa-solid fa-envelope" aria-hidden="true"></i>
                </div>
                <h2 className="text-lg sm:text-xl font-display font-bold text-white uppercase">Send en e-mail</h2>
                <p className="text-xs text-zinc-400 mt-2 leading-relaxed">
                  Send os en besked eller projektbeskrivelse direkte til vores e-mail.
                </p>
                <div className="mt-6 pt-4 border-t border-zinc-800">
                  <p className="text-[10px] text-zinc-500 uppercase font-mono font-semibold">E-mailadresse</p>
                  <a
                    href="mailto:Agstnerbyg@icloud.com"
                    className="text-xs sm:text-sm font-bold text-orange-500 hover:text-orange-400 transition-colors whitespace-nowrap inline-block mt-0.5 break-all"
                  >
                    <span>Agstnerbyg@icloud.com</span>
                  </a>
                </div>
              </div>
              <a
                href="mailto:Agstnerbyg@icloud.com"
                className="w-full py-3.5 px-4 bg-zinc-900 hover:bg-orange-500 hover:text-zinc-950 text-orange-500 font-display font-bold text-xs uppercase tracking-widest border border-zinc-800 text-center transition-all whitespace-nowrap"
              >
                Send mail
              </a>
            </div>

            {/* Box 3: Facebook */}
            <div className="bg-zinc-950 p-6 sm:p-8 border border-zinc-800 hover:border-orange-500 transition-all flex flex-col justify-between space-y-6">
              <div>
                <div className="w-12 h-12 bg-orange-500 text-zinc-950 flex items-center justify-center font-bold text-xl mb-6">
                  <i className="fa-brands fa-facebook-f" aria-hidden="true"></i>
                </div>
                <h2 className="text-lg sm:text-xl font-display font-bold text-white uppercase">Facebook</h2>
                <p className="text-xs text-zinc-400 mt-2 leading-relaxed">
                  Følg med på vores officielle Facebook-side og se billeder fra igangværende projekter.
                </p>
                <div className="mt-6 pt-4 border-t border-zinc-800">
                  <p className="text-[10px] text-zinc-500 uppercase font-mono font-semibold">Sociale medier</p>
                  <a
                    href="https://www.facebook.com/profile.php?id=61590981091175"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs sm:text-sm font-bold text-orange-500 hover:text-orange-400 transition-colors whitespace-nowrap inline-flex items-center gap-1.5 mt-0.5"
                  >
                    <span>Agstner Byg på Facebook</span>
                    <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <a
                href="https://www.facebook.com/profile.php?id=61590981091175"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-3.5 px-4 bg-zinc-900 hover:bg-orange-500 hover:text-zinc-950 text-orange-500 font-display font-bold text-xs uppercase tracking-widest border border-zinc-800 text-center transition-all whitespace-nowrap inline-flex items-center justify-center gap-2"
              >
                <span>Følg os</span>
                <i className="fa-brands fa-facebook" aria-hidden="true"></i>
              </a>
            </div>

            {/* Box 4: Adresse */}
            <div className="bg-zinc-950 p-6 sm:p-8 border border-zinc-800 hover:border-orange-500 transition-all flex flex-col justify-between space-y-6">
              <div>
                <div className="w-12 h-12 bg-orange-500 text-zinc-950 flex items-center justify-center font-bold text-xl mb-6">
                  <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                </div>
                <h2 className="text-lg sm:text-xl font-display font-bold text-white uppercase">Adresse</h2>
                <div className="mt-4 space-y-1.5 text-xs text-zinc-300">
                  <p className="font-display font-bold text-white uppercase">Agstner Byg ApS</p>
                  <p className="text-zinc-400">Odensevej 36</p>
                  <p className="text-zinc-400">5492 Vissenbjerg</p>
                  <p className="text-[11px] text-zinc-500 font-mono pt-2 border-t border-zinc-800">CVR: 44000997</p>
                </div>
              </div>
              <a
                href="#formular"
                className="w-full py-3.5 px-4 bg-orange-500 hover:bg-orange-600 text-zinc-950 font-display font-bold text-xs uppercase tracking-widest text-center transition-all border border-orange-500"
              >
                Tilbudsformular
              </a>
            </div>

          </div>

          {/* Form */}
          <div id="formular" className="max-w-3xl mx-auto">
            <ContactForm />
          </div>

        </div>
      </section>
    </>
  )
}
